const getNumberByLetter = (letter: string) => {
    return letter.charCodeAt(0) - 65;
};

export default getNumberByLetter;
